import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import Title from '../Components/Title';
import ReviewItem from '../Components/ReviewItem';
import avatar from '../img/avatar.jpg';

function ReviewsSection() {
  return (
    <ReviewsStyled>
      <Title title={'Favourite Quotes'} span={'Favourite Quotes'} />
      <InnerLayout>
        <div className="reviews">
          <ReviewItem
            quote={
              'Any fool can write code that a computer can understand. Good programmers write code that humans can understand.'
            }
            author={'Martin Fowler'}
            img={avatar}
          />

          <ReviewItem
            quote={
              'A designer knows he has achieved perfection not when there is nothing left to add, but when there is nothing left to take away.'
            }
            author={'Antoine de Saint-Exupéry'}
          />
        </div>
      </InnerLayout>
    </ReviewsStyled>
  );
}

const ReviewsStyled = styled.section`
  .reviews {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5rem;
    width: 100%;
    padding-bottom: 1rem;

    @media screen and (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export default ReviewsSection;
